export function PageCardSkeleton() {
  return (
    <div className="tw-w-full tw-min-w-[920px] tw-min-h-[250px] tw-bg-search-grey/10 tw-animate-pulse"></div>
  )
};